var render = function () {
  var _vm$booking, _vm$booking2, _vm$booking3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-simple', [_c('v-container', [_c('v-card', {
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(((_vm$booking = _vm.booking) === null || _vm$booking === void 0 ? void 0 : _vm$booking.displayName) || "Terminbuchung") + " ")]), _c('v-card-subtitle', [_vm._v(" " + _vm._s((_vm$booking2 = _vm.booking) === null || _vm$booking2 === void 0 ? void 0 : _vm$booking2.description) + " ")]), !_vm.isLoading ? _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-date-picker', {
    ref: "bookingPicker",
    staticClass: "booking-datepicker ml-4",
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "picker-date": _vm.pickerDate,
      "calendar-class": "booking-datepicker_calendar",
      "allowed-dates": _vm.allowedDates,
      "full-width": "",
      "flat": "",
      "show-week": "",
      "color": _vm.color,
      "locale": "de-de",
      "first-day-of-week": "1"
    },
    on: {
      "update:pickerDate": function updatePickerDate($event) {
        _vm.pickerDate = $event;
      },
      "update:picker-date": function updatePickerDate($event) {
        _vm.pickerDate = $event;
      }
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }), _c('v-card-subtitle', [_vm._v(" Timeslot "), _c('v-chip', [_vm._v(_vm._s(_vm.durationInMinutes) + " min")]), _vm._v(" Timezone "), _c('v-chip', [_vm._v(_vm._s(new Date().toString().substring(24, 33)))])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [!_vm.slotsForDay || _vm.slotsForDay.length < 1 ? _c('v-row', {
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('latest-entries-card-empty')], 1) : _c('v-virtual-scroll', {
    attrs: {
      "height": "600",
      "item-height": "64",
      "items": _vm.slotsForDay
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-list', [_c('v-list-item', {
          key: "item"
        }, [item && item.startInSeconds ? _c('v-btn', {
          attrs: {
            "block": "",
            "large": "",
            "elevation": "0",
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              return _vm.selectSlot(item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm._f("formatHoursAndMinutes")(_vm.displayTimeSlot(item))) + " ")]) : _vm._e()], 1)], 1)];
      }
    }], null, false, 3115152040)
  })], 1)], 1) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-two-line, card"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  })], 1)], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "subtitle": _vm.slotSubtitle(),
      "title": ((_vm$booking3 = _vm.booking) === null || _vm$booking3 === void 0 ? void 0 : _vm$booking3.displayName) || '',
      "rightLoading": _vm.isDialogLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isDialogActive = false;
      },
      "rightClick": _vm.bookSlot
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('booking.BookingAvailability.firstName'),
      "data-test-firstName": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.customerInformation.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.customerInformation, "firstName", $$v);
      },
      expression: "customerInformation.firstName"
    }
  }), _c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('booking.BookingAvailability.lastName'),
      "data-test-lastName": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.customerInformation.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.customerInformation, "lastName", $$v);
      },
      expression: "customerInformation.lastName"
    }
  }), _c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('booking.BookingAvailability.email'),
      "type": "email",
      "data-test-email": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.customerInformation.email,
      callback: function callback($$v) {
        _vm.$set(_vm.customerInformation, "email", $$v);
      },
      expression: "customerInformation.email"
    }
  }), _c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('booking.BookingAvailability.phone'),
      "type": "tel",
      "data-test-phone": ""
    },
    model: {
      value: _vm.customerInformation.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.customerInformation, "phone", $$v);
      },
      expression: "customerInformation.phone"
    }
  }), _c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('booking.BookingAvailability.numberplate'),
      "type": "tel",
      "data-test-numberplate": ""
    },
    model: {
      value: _vm.customerInformation.numberPlate,
      callback: function callback($$v) {
        _vm.$set(_vm.customerInformation, "numberPlate", $$v);
      },
      expression: "customerInformation.numberPlate"
    }
  }), _c('v-textarea', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('booking.BookingAvailability.notes'),
      "data-test-notes": ""
    },
    model: {
      value: _vm.bookingInformation.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingInformation, "notes", $$v);
      },
      expression: "bookingInformation.notes"
    }
  })], 1)], 1), _c('debug', [_vm._v(" " + _vm._s(_vm.booking) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }